<template>
  <div id="app">
      <loading :show="loading" :label="label">
    </loading>
    <router-view></router-view>
    <vue-snotify></vue-snotify>
  </div>
</template>

<script>
import loading from 'vue-full-loading'
import { mapState } from'vuex'

export default {
  name: 'app',
  inject: ['eventBus'],
  components: {
    loading
  },
  computed : {
    ...mapState({
      loading : state => state.loading.loading
    })
  },
  data () {
    return {
      label : 'Loading'
    }
  },
  methods : {
    notify() {
      this.$snotify.simple({
        body: 'New order is comming!',
        title: 'Notification',
        config: {}
      });
    }
  },
  async created () {
    await this.$store.dispatch('restaurants/getRestaurantsAction');
  },
  mounted () {
    this.eventBus.$on("newOrderEvent", this.notify);
  }
}
</script>

<style>
  @import "../node_modules/mdi/css/materialdesignicons.min.css";
  @import "../node_modules/flag-icon-css/css/flag-icon.min.css";
  @import "../node_modules/font-awesome/css/font-awesome.min.css";
  @import "../node_modules/simple-line-icons/css/simple-line-icons.css";
  @import "../node_modules/ti-icons/css/themify-icons.css";
  @import "../node_modules/fullcalendar/dist/fullcalendar.min.css";
  @import "../node_modules/codemirror/lib/codemirror.css";
  @import "../node_modules/vue-snotify/styles/material.css"; 
  @import "../node_modules/vue-multiselect/dist/vue-multiselect.min.css";
  @import "../node_modules/ant-design-vue/dist/antd.css";
  @import '../node_modules/please-wait/build/please-wait.css';
  @import '../node_modules/vue-slider-component/theme/default.css'
</style>

<style lang="scss">
@import "./assets/scss/style";
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>